import { Box, Typography } from "@mui/material";
import { HStack } from "Components/_Shared/Core/Stack";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { TimelinePill } from "./TimelinePill";
import { TimelineAxisCell, TimelineContentCell, TimelineDateCell, TimelineRow } from "./TimelineRow";
import { formatMonthYear } from "./utils/dates";

export const TodayMarker = () => {
  const { t } = useResource();

  return (
    <TimelineRow height={48} alignItems="center">
      <TimelineDateCell>
        <Typography fontSize={14} fontWeight={700} color="primary.main">
          {formatMonthYear(new Date())}
        </Typography>
      </TimelineDateCell>

      <TimelineAxisCell>
        <Box
          width={14}
          height={14}
          borderRadius={Radius.MAX}
          bgcolor="primary.main"
          sx={(theme) => ({ boxShadow: `0 0 0 4px ${theme.palette.primary.light}` })}
        />
      </TimelineAxisCell>

      <TimelineContentCell>
        <HStack alignItems="center" gap={Spacing.L}>
          <TimelinePill height={24} bgcolor="primary.main" color="primary.contrastText">
            {t(Resources.AnalysisDetail.Goals.Timeline.Today)}
          </TimelinePill>
          <Box flex={1} borderTop={1} sx={(theme) => ({ borderColor: theme.colors.brandLightBorder })} />
        </HStack>
      </TimelineContentCell>
    </TimelineRow>
  );
};
